import React from "react"
import {
  Card,
  Button,
  Row,
  Col,
  UncontrolledTooltip,
  CardBody,
} from "reactstrap"
import { convertToDateTimeString, hasPermission } from "helpers/helpers"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { withRouter } from "react-router-dom" // Import withRouter
import axios from "axios"
import { API_URL } from "constants/constants"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

class Table extends React.Component {
  state = {
    data: this.props.data, // Initialize local state with props data
  }

  componentDidUpdate(prevProps) {
    // Update local state if props data changes
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data })
    }
  }

  handleClick = (row, e) => {
    e.preventDefault()
    this.props.history.push({
      pathname: `/promotions/AutometedFreeSpin/${row.freespin_id}`,
      state: { rowData: row }, // Pass the entire row object or specific data
    })
    //this.props.history.push(`/promotions/Freebets/view/${row.freespin_id}`);
  }

  deleteClick = (row, e) => {
    e.preventDefault()
    axios
      .post(`${API_URL}/slotegrator/cancelfreeSpin`, {
        freespin_id: row.freespin_id, // Send freespin_id directly in the request body
      })
      .then(response => {
        // console.log(response);
        toastr.success(
          response?.data?.message || "Free Spin data deleted successfully"
        )

        // Update local state to remove the deleted row
        this.setState(prevState => ({
          data: prevState.data.filter(
            item => item.freespin_id !== row.freespin_id
          ),
        }))
      })
      .catch(error => {
        console.error("Error deleting free spin data:", error)
        toastr.error("Failed to delete Free Spin data. Please try again.")
      })
  }

  render() {
    const { data } = this.state

    const columns = [
      {
        dataField: "freespin_id",
        text: "Free Spin ID",
        sort: true,
      },
      {
        dataField: "game_name",
        text: "Game Name",
        sort: true,
      },
      {
        dataField: "provider_name",
        text: "Provider Name",
        sort: true,
      },
      {
        dataField: "player",
        text: "Player ID",
        sort: true,
      },
      {
        dataField: "player_phone_number",
        text: "Phone Number",
        sort: true,
      },
      {
        dataField: "deposit",
        text: "Deposit",
        sort: true,
      },
      {
        dataField: "time_period",
        text: "Time Period",
        sort: true,
      },
      {
        dataField: "product",
        text: "Product",
        sort: true,
      },
      {
        dataField: "freespin_by_name",
        text: "Created By",
        sort: true,
      },
      {
        dataField: "start_date",
        text: "Start Date",
        sort: true,
        headerStyle: { width: "250px" },
        formatter: (cell, row) => {
          const date = new Date(row?.start_date)
          const formattedDate = date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          })
          const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
            match.toUpperCase()
          )

          return <>{capitalizedDate}</>
        },
      },
      {
        dataField: "end_date",
        text: "End Date",
        sort: true,
        headerStyle: { width: "250px" },
        formatter: (cell, row) => {
          const date = new Date(row?.end_date)
          const formattedDate = date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          })
          const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
            match.toUpperCase()
          )

          return <>{capitalizedDate}</>
        },
      },
      {
        dataField: "created_at",
        text: "Created At",
        sort: true,
        headerStyle: { width: "250px" },
        formatter: (cell, row) => {
          const date = new Date(row?.created_at)
          const formattedDate = date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          })
          const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
            match.toUpperCase()
          )

          return <>{capitalizedDate}</>
        },
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        formatter: (cellContent, row) => (
          <div className="d-flex gap-3">
            {hasPermission("view-autofreespin") && (
              <Button
                color="link"
                className="text-primary"
                onClick={e => this.handleClick(row, e)}
              >
                <i
                  className="mdi mdi-eye font-size-18"
                  id={`viewtooltip-${row.freespin_id}`}
                />
                <UncontrolledTooltip
                  placement="top"
                  target={`viewtooltip-${row.freespin_id}`}
                >
                  View
                </UncontrolledTooltip>
              </Button>
            )}
            {hasPermission("delete-autofreespin") && (
              <Button
                color="link"
                className="text-danger"
                onClick={e => this.deleteClick(row, e)}
              >
                <i
                  className="mdi mdi-delete font-size-18"
                  id={`deletetooltip-${row.freespin_id}`}
                />
                <UncontrolledTooltip
                  placement="top"
                  target={`deletetooltip-${row.freespin_id}`}
                >
                  Delete
                </UncontrolledTooltip>
              </Button>
            )}
          </div>
        ),
      },
    ]

    const defaultSorted = [
      {
        dataField: "created_at",
        order: "desc",
      },
    ]

    const { SearchBar } = Search

    const pageOptions = {
      sizePerPage: 10,
      totalSize: data.length,
      custom: true,
    }

    return (
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">Automated Freebets List</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="freespin_id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="freespin_id"
                data={data}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <>
                    <Row className="mb-2">
                      <Col sm="4">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div className="position-relative">
                            <SearchBar {...toolkitProps.searchProps} />
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>
                      </Col>
                      <Col sm="8">
                        <div className="text-sm-end">
                          {hasPermission("create-autofreespin") && (
                            <Button
                              type="button"
                              color="success"
                              className="btn-rounded mb-2 me-2"
                              onClick={() =>
                                this.props.history.push(
                                  "/promotions/AutometedFreeSpin/create"
                                )
                              }
                            >
                              <i className="mdi mdi-plus me-1" />
                              Create Freebets
                            </Button>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="freespin_id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            classes="table align-middle table-nowrap table-check"
                            headerWrapperClasses="table-light"
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses="mytable-hover-row"
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    )
  }
}

export default withRouter(Table)
